<template>
  <div class="container">
    <div class="my-md-5 my-4 text-center">
      <div v-html="$t('Footer.legalrules')" class="short-rules"></div>
    </div>
  </div>
  <footer class="">
   <div class="container-fluid">
      <div class="navbar">
        
      <ul class="list-inline mb-0" id="footer-nav">
        <li class="list-inline-item ps-0">
              <router-link
                to="/Home"                
                aria-label="Home"
                alt="Home"
                >{{ $t('Footer.Home') }}
              </router-link>
            </li>
            <li class="list-inline-item">
              <router-link
                to="/ReceiptTroubleshooting"                
                aria-label="Receipt Troubleshooting"
                alt="Receipt Troubleshooting"
                >{{$t('Footer.ReceiptTroubleshooting')}}
              </router-link>
            </li>
      
        <li class="list-inline-item" v-html="$t('Footer.T&CLink')">   
        </li>
        <li class="list-inline-item" v-html="$t('Footer.FAQlink')">   
        </li>
        <li class="list-inline-item" v-html="$t('Footer.ContactUsLink')">   
        </li>
        <li class="list-inline-item" v-html="$t('Footer.CookiePreference')">              
            </li>
        <li class="list-inline-item" v-html="$t('Footer.PrivayPolicyLink')">   
        </li>        
        <li class="list-inline-item" v-html="$t('Footer.SnippPrivacyPolicyLink')">   
        </li>
        <li class="list-inline-item" v-html="$t('Footer.TermsOfUseLink')">   
        </li>
        <li class="list-inline-item" v-html="$t('Footer.DNSLink')">   
        </li>
        <li class="list-inline-item" v-html="$t('Footer.AccessibilityLink')">   
        </li>
      </ul>
      </div>
      <div class="">
        <span>{{$t('Footer.copyrighttext')}} © {{ new Date().getFullYear() }} {{$t('Footer.AllrightReserved')}}</span>
      </div>
      </div>
 
  </footer>
</template>

<script>
//Younet chatbot code apprended in the body
export default {
  mounted() {
    // // Dynamically fetch the translated modelHash
    // const modelHash = this.$t('YounetmodelHash');
    // const modelImgurl = this.$t('YounetmodelIMg');
    // const scriptUrl = `https://widget.younet.ai/index.js?modelHash=${modelHash}&type=bubble&imgUrl=${modelImgurl}`;

    // // Dynamically create the script element
    // const script = document.createElement('script');
    // script.type = 'module';
    // script.src = scriptUrl;

    // // Append the script to the body
    // document.body.appendChild(script);
  },
};
</script>


